'use client'

import dynamic from 'next/dynamic'

import { HeroBackground, Spotlight } from 'design-studio'

const ThreeHero = dynamic(
  () =>
    import('design-studio').then((mod) => ({
      default: mod.ThreeHero,
    })),
  { ssr: false },
)

export function HomeBackground({ mountCanvas }: { mountCanvas: boolean }) {
  return (
    <HeroBackground className="h-[min(110vh,1600px)]">
      {mountCanvas && <ThreeHero />}
      <Spotlight
        color="from-cyan-600/20"
        className="-top-200 -left-230 size-512"
      />
      <Spotlight
        color="from-teal-600/20"
        className="fixed -right-200 -bottom-250 size-512"
      />
      <div className="bg-radial-gradient mx-auto h-[1600px] w-[1600px] translate-x-[100px] -translate-y-[250px] rounded-full from-[#6073EC] via-transparent md:h-[1700px] md:w-[1800px] md:translate-x-[160px] md:-translate-y-[350px] lg:translate-x-[440px]"></div>
      <div className="absolute inset-0 bg-white/10 dark:bg-slate-900/10" />
    </HeroBackground>
  )
}
